import React, { useEffect, useState} from "react";
import {searchCalculatorParamsToArray} from '../util/flightUrlParamParser'
import {initialiseAviationGoogleAnalyticsWithCustomerProdTrackingId} from '../util/ccanalytics'
import config from "../../config";
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'

import FlightCalculatorWidget from "@carbonclick/flight-calculator-library/dist/flight-calculator-lib";

const flightCalcConfig = {
  API_KEY: config.carbon_app_api_key, 
  API_URL: config.api_url,
  STRIPE_CLIENT_ID: config.stripe_api_key,
  MYCC_BASE_URL: config.mycc_base_url
}

const FlightCalculatorWidgetEmbedded = ({loadingPlaceholder}) => {

  const urlData = searchCalculatorParamsToArray(new URLSearchParams(window.location.search));

    useEffect(() => {
            let merchantCode = urlData?.merchantCode ? urlData?.merchantCode : 'CARBONCLICK';
            initialiseAviationGoogleAnalyticsWithCustomerProdTrackingId(merchantCode);
            ReactGA.pageview('/flight-calculator-iframe', ['aviation', 'customer']);


            //the flight calculator library fires post messages if gtag is not defined;
            //this allows the parent page to listen for these events and manage the analytics
            if(urlData?.analyticsMode !== 'POST_MESSAGE') {
              window.dataLayer=[];

              //Not entirely sure why I needed this, but got it working (including additiona params); see https://developers.google.com/analytics/devguides/migration/ecommerce/gtm-ga4-to-ua
              function gtag() {
                window.dataLayer.push(arguments);
              }

              window.gtag = gtag;

              gtag('set', {
                'cookie_flags': 'SameSite=None;Secure' //Should include Secure in deployed (https) environments
                // 'cookie_flags': 'SameSite=None'
              });
              // list of supported session variables
              // is configured in Tag Manager Workspace
              gtag('set', {merchant_code: merchantCode});

                const googleTagManagers = [{id: config.gtm_id, preview: config.gtm_preview, auth: config.gtm_auth}];

                for (const tagManager of googleTagManagers) {
                    if (tagManager) {
                        TagManager.initialize({gtmId: tagManager.id, auth: tagManager.auth, preview: tagManager.preview});
                    }
                }


            }
        }, []
    );

  return (
    <div className='translate-dynamic'>
      <FlightCalculatorWidget
      loadingPlaceholder={loadingPlaceholder}
      config={flightCalcConfig}
      flightStrings={urlData?.flightParams}
      currency={urlData?.currency}
      pax={urlData?.pax}
      merchantCode={urlData?.merchantCode}
      programmeCode={urlData?.programmeCode}
      country={urlData.country}
      destination={urlData.destination}
      />
    </div>
  );
};

export default FlightCalculatorWidgetEmbedded;